import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

/**
 * 地図の状態
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
